import { extend } from 'vee-validate';

extend('between', {
    validate(value, { min, max }: any) {
        return parseInt(value) >= min && parseInt(value) <= max;
    },
    params: ['min', 'max'],
    message: 'The {_field_} field must be between {min} and {max}'
});
